/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	// ピックアップスライドの処理
	const pickupSlides = async () => {
		const pickupSlidesWrap = document.querySelector('.js-pickupSlidesWrap');
		if (!pickupSlidesWrap) return;

		const pickupSlides = document.querySelectorAll('.js-pickupSlide');
		if (pickupSlides.length === 0) {
			pickupSlidesWrap.remove();
			return;
		}

		// 各スライドのタグを取得して描画
		const fetchPromises = Array.from(pickupSlides).map(async (slide) => {
			// .js-pickupContent が存在しない場合は空スライドと判定
			const contentSection = slide.querySelector('.js-pickupContent');
			if (!contentSection) {
				return { slide, isEmpty: true };
			}

			const pickupIdElement = slide.querySelector('.js-pickupId');
			if (!pickupIdElement) {
				return { slide, isEmpty: false };
			}

			const pickupId = pickupIdElement.textContent.trim();
			if (!pickupId) {
				return { slide, isEmpty: false };
			}

			try {
				const response = await fetch(`/ajax/vmpinfo/pick_up/${pickupId}.json`);
				if (!response.ok) throw new Error('Failed to fetch');
				
				const data = await response.json();
				const tagList = data?.rt_bn_news_tag_list?.[0]?.cf_n_tags;
				
				if (!tagList || tagList.length === 0) return { slide, isEmpty: false };

				// タグコンテナを取得
				const tagContainer = slide.querySelector('.js-tag-container');
				if (tagContainer) {
					const tagClassMap = {
						'告知': '_announcement',
						'障害': '_impediment',
						'要確認': '_confirmation',
						'お詫び': '_apology',
					};

					// タグのHTMLを生成して挿入
					const tagsHTML = tagList.map(tag => {
						const tagClass = tagClassMap[tag.cf_nt_name] || '';
						return `<p class="mod-tag02"><span class="${tagClass}">${tag.cf_nt_name}</span></p>`;
					}).join('');
					
					tagContainer.innerHTML = tagsHTML;
					
					// タグ挿入後、少し待ってからクラスを削除（レイアウトが確定してから）
					setTimeout(() => {
						const tagSpans = tagContainer.querySelectorAll('.mod-tag span');
						tagSpans.forEach(span => {
							span.classList.remove('mod-text-invisible');
						});
					}, 0);
				}
				
				return { slide, isEmpty: false };
			} catch (error) {
				console.error(`Failed to fetch tags for ID ${pickupId}:`, error);
				return { slide, isEmpty: false };
			}
		});

		const results = await Promise.all(fetchPromises);
		
		// 空のスライドを削除
		results.forEach(({ slide, isEmpty }) => {
			if (isEmpty) {
				slide.remove();
			}
		});

		// スライダーの存在確認と削除処理
		const slider = document.querySelector('.js-slider01');
		const remainingSlides = pickupSlidesWrap.querySelectorAll('.js-pickupSlide');
		
		if (!slider || remainingSlides.length === 0) {
			pickupSlidesWrap.remove();
		} else {
			// タグ描画完了後、Splideを再マウント
			remountSplide(slider);
		}
	};

	// Splide再マウントの処理
	const remountSplide = (slideElement) => {
		// 既存のSplideインスタンスを破棄
		if (slideElement.splide) {
			slideElement.splide.destroy();
		}

		// スライド数を再計算
		const slideCount = slideElement.querySelectorAll('.splide__slide:not(.splide__slide--clone)').length;
		
		if (slideCount === 0) return;

		// 新しいSplideインスタンスを作成
		const splideInstance = new Splide(slideElement, {
			type: 'loop',
			autoplay: true,
			interval: 5000,
			speed: 2000,
			perPage: 3,
			perMove: 1,
			gap: '40px',
			pauseOnHover: true,
			pauseOnFocus: true,
			arrows: true,
			pagination: false,
			breakpoints: {
				1024: {
					perPage: 1,
					gap: '16px',
				},
			},
			classes: {
				arrows: 'splide__arrows mod-slider-arrows',
				arrow: 'splide__arrow mod-slider-arrow',
				prev: 'splide__arrow--prev mod-slider-prev',
				next: 'splide__arrow--next mod-slider-next'
			},
		});

		// インデックス表示の更新
		const currentElement = slideElement.querySelector('.slide-current');
		const lengthElement = slideElement.querySelector('.slide-length');
		
		function updateSlideIndex() {
			if (currentElement && lengthElement) {
				const slides = splideInstance.Components.Slides.get();
				const originalSlides = slides.filter(slide => !slide.isClone);
				const totalOriginal = originalSlides.length;
				
				let currentIndex = splideInstance.index;
				if (splideInstance.Components.Slides.getAt(currentIndex).isClone) {
					currentIndex = splideInstance.Components.Slides.getAt(currentIndex).slideIndex;
				}
				
				const current = String(currentIndex + 1).padStart(2, '0');
				const total = String(totalOriginal).padStart(2, '0');
				currentElement.textContent = current;
				lengthElement.textContent = total;
			}
		}

		splideInstance.on('overflow', function (isOverflow) {
			splideInstance.go(0);
			splideInstance.options = {
				arrows : isOverflow,
				pagination: isOverflow,
				drag : isOverflow,
				clones : isOverflow ? undefined : 0,
			};
		});
		
		splideInstance.on('move', updateSlideIndex);
		splideInstance.mount();
		updateSlideIndex();
	};

	// フリーワード検索の処理
	const freewordSearch = () => {
		const searchForm = document.querySelector('.js-freeword-search');
		const searchInput = document.querySelector('.js-freeword-search-keyword');
		const searchBtn = document.querySelector('.js-freeword-search-btn');
		const searchAnchor = '#js-vmpinfo-top';

		if (!searchInput || !searchBtn || !searchForm) return;

		// URLパラメータから検索キーワードを復元
		const urlParams = new URLSearchParams(window.location.search);
		const keywords = [];
		for (let i = 1; i <= 3; i++) {
			const keyword = urlParams.get(`p_keyword_${i}`);
			if (keyword) {
				keywords.push(keyword);
			}
		}
		if (keywords.length > 0) {
			searchInput.value = keywords.join(' ');
		}

		// フォームのsubmitイベントを処理
		searchForm.addEventListener('submit', (e) => {
			e.preventDefault();

			// 既存のhidden inputを削除
			const existingInputs = searchForm.querySelectorAll('input[type="hidden"][name^="p_keyword"], input[type="hidden"][name^="p_block"]');
			existingInputs.forEach(input => input.remove());

			// 入力値を取得
			const inputValue = searchInput.value.trim();
			
			// 入力値が空の場合は、パラメータなしでフォーム送信
			if (!inputValue) {
				searchForm.method = 'GET';
				searchForm.action = window.location.pathname;
				searchForm.submit();
				return;
			}

			// ダブルクォートを削除、NFKC正規化、スペースで分割して最大3ワードまで取得
			const keywords = inputValue.replaceAll(/["]/g, '').normalize('NFKC').split(/\s+/).filter(word => word).slice(0, 3);

			if (keywords.length === 0) {
				searchForm.method = 'GET';
				searchForm.action = window.location.pathname;
				searchForm.submit();
				return;
			}

			// フォームのmethodとactionを設定（現在のパスを維持）
			searchForm.method = 'GET';
			searchForm.action = `${window.location.pathname}${searchAnchor}`;

			// hidden inputを動的に追加
			keywords.forEach((keyword, index) => {
				const num = index + 1;
				// XSS対策: 値をエスケープ
				const escapedKeyword = keyword.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
				
				const keywordInput = document.createElement('input');
				keywordInput.type = 'hidden';
				keywordInput.name = `p_keyword_${num}`;
				keywordInput.value = keyword;
				
				const blockInput = document.createElement('input');
				blockInput.type = 'hidden';
				blockInput.name = `p_block_${num}`;
				blockInput.value = keyword;
				
				searchForm.appendChild(keywordInput);
				searchForm.appendChild(blockInput);
			});

			// フォーム送信
			searchForm.submit();
		});
	};

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const vmpinfoFUNCTIONS = async () => {
		// setting.jsのslider01()初期化を待つ（最大500ms）
		const waitForSplide = () => {
			return new Promise((resolve) => {
				const slider = document.querySelector('.js-slider01');
				if (!slider) {
					resolve();
					return;
				}

				let attempts = 0;
				const checkInterval = setInterval(() => {
					attempts++;
					// Splideが初期化されたか、またはタイムアウト（500ms / 50ms = 10回）
					if (slider.splide || attempts >= 10) {
						clearInterval(checkInterval);
						resolve();
					}
				}, 50);
			});
		};

		await waitForSplide();
		await pickupSlides();
		freewordSearch();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { vmpinfoFUNCTIONS(); }) : vmpinfoFUNCTIONS();

})(window.FUNCTIONS);
